import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsLoading,
  setErrorMessage,
  setSuccessMessage,
} from "../../store/patient/formEventSlice";
import { setSchedule, clearSchedule } from "../../store/patient/scheduleSlice";
import { translations } from "../../helpers";
import { gosafeApi } from "../../api";

export const useScheduleStore = () => {
  const dispatch = useDispatch();

  const { schedule } = useSelector((state) => state.patient.schedule);
  const { patientSurgery } = useSelector(
    (state) => state.patient.patientSurgery
  );

  const startGetScheduleBySurgeryRoomId = useCallback(
    async ({ surgeryRoomId }) => {
      try {
        dispatch(setIsLoading());

        const { id: patientSurgeryId } = patientSurgery.data;

        const { data } = await gosafeApi.get(
          `scheduleEvent/bySurgeryRoomIdPatientSurgeryId/${surgeryRoomId}/${patientSurgeryId}`
        );

        dispatch(setSchedule(data));
        dispatch(setSuccessMessage(translations[data.message] || data.message));
        return;
      } catch (error) {
        dispatch(
          setErrorMessage(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
        return;
      }
    },
    [dispatch, patientSurgery.data]
  );

  const getScheduleByDoctorHeadquarterScheduleId = useCallback(
    async ({ doctorHeadquarterScheduleId }, queryStringParameters) => {
      try {
        dispatch(setIsLoading());

        const { id: patientSurgeryId } = patientSurgery.data;

        const params = Object.fromEntries(
          Object.entries({
            ...queryStringParameters,
          }).filter(([_, value]) => value !== "")
        );

        const { data } = await gosafeApi.get(
          `patientSurgery/schedule/byDoctorHeadquarterScheduleIdPatientSurgeryId/${doctorHeadquarterScheduleId}/${patientSurgeryId}`,
          { params }
        );

        dispatch(setSchedule(data));
        dispatch(setSuccessMessage(translations[data.message] || data.message));
        return;
      } catch (error) {
        dispatch(
          setErrorMessage(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
        return;
      }
    },
    [dispatch, patientSurgery.data]
  );

  const startClearSchedule = useCallback(() => {
    dispatch(clearSchedule());
  }, [dispatch]);

  return {
    // Props
    schedule,

    // Methods
    startGetScheduleBySurgeryRoomId,
    startClearSchedule,
    getScheduleByDoctorHeadquarterScheduleId,
  };
};
